<script setup lang="ts">
import Tag from '~/components/ui/tag/Tag.vue';

withDefaults(defineProps<{ onLightSurface?: boolean }>(), {
	onLightSurface: false
});
</script>

<template>
	<Tag
		variant="translucent"
		class="min-h-6 w-fit max-w-full gap-1 px-2 py-[3px] xl:py-[3px]"
		:class="onLightSurface ? 'text-primary' : 'text-white'"
		:text-class="
			onLightSurface ? 'text-left text-primary' : 'text-left text-white'
		"
	>
		<template v-if="$slots.icon" #icon>
			<slot name="icon" />
		</template>
		<slot />
	</Tag>
</template>
